
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'


import { Core } from '../core/core'
import { SeAvatarModule, SE_AVATAR_MODULE_BUNDLE } from '../avatar/avatar.module'
import { SeIconModule, SE_ICON_MODULE_BUNDLE } from '../icon/icon.module'

import { SeCountAvatarComponent } from './count-avatar.component'

@NgModule({
  declarations: [
    SeCountAvatarComponent,
  ],
  imports: [
	CommonModule, 
    SeAvatarModule,
    SeIconModule,
  ],
  exports: [
    SeCountAvatarComponent,
  ]
})
export class SeCountAvatarModule { }

export const SE_COUNT_AVATAR_MODULE_BUNDLE = `${Core.ANGULAR_MODULE}.countAvatar`

